// static/table_engine_src/core/dp_overrides.js
import { clampInt } from "../util/number.js";

/**
 * Per-column decimals override store (localStorage/sessionStorage).
 * Installs:
 *   ctx.getDpOverride(colKey) -> number|null
 *   ctx.setDpOverride(colKey, dpOrNull)
 */
export function installDpOverrides(ctx) {
  const spec = ctx?.spec || {};
  const tableId = spec.tableId || spec.rootId || "table";

  const storageKey =
    spec.decimalsStorageKey || spec.storageKey || `te.dpOverrides::${tableId}`;

  const store = (() => {
    try {
      return spec.dpOverrideStorage === "session"
        ? window.sessionStorage
        : window.localStorage;
    } catch {
      return null;
    }
  })();

  function load() {
    if (!store) return {};
    try {
      const raw = store.getItem(storageKey);
      if (!raw) return {};
      const obj = JSON.parse(raw);
      return obj && typeof obj === "object" ? obj : {};
    } catch {
      return {};
    }
  }

  function save(obj) {
    if (!store) return;
    try {
      store.setItem(storageKey, JSON.stringify(obj || {}));
    } catch {
      // ignore quota / private mode
    }
  }

  let dpOverrides = load();

  ctx.getDpOverride = function getDpOverride(colKey) {
    const v = dpOverrides?.[colKey];
    if (Number.isFinite(v)) return clampInt(v, 0, 12);
    return null;
  };

  ctx.setDpOverride = function setDpOverride(colKey, dpOrNull) {
    if (!colKey) return;

    if (dpOrNull === null || dpOrNull === undefined) {
      if (dpOverrides && Object.prototype.hasOwnProperty.call(dpOverrides, colKey)) {
        delete dpOverrides[colKey];
        save(dpOverrides);
      }
      return;
    }

    const dp = clampInt(dpOrNull, 0, 12);
    dpOverrides = dpOverrides && typeof dpOverrides === "object" ? dpOverrides : {};
    dpOverrides[colKey] = dp;
    save(dpOverrides);
  };

  // optional debug/visibility
  ctx._dpOverridesKey = storageKey;
}